export default "__VITE_ASSET__dba00598__"